export const platformActorKinds = [
  "workforce-user",
  "platform-operator",
  "service-account",
] as const;

export type PlatformActorKind = (typeof platformActorKinds)[number];

export const platformActorStatuses = [
  "draft",
  "active",
  "inactive",
  "suspended",
] as const;

export type PlatformActorStatus = (typeof platformActorStatuses)[number];

export const membershipScopeKinds = [
  "tenant",
  "site",
  "department",
  "service-line",
  "program",
  "care-team",
] as const;

export type MembershipScopeKind = (typeof membershipScopeKinds)[number];

export const tenantMembershipStatuses = [
  "invited",
  "active",
  "suspended",
  "revoked",
] as const;

export type TenantMembershipStatus = (typeof tenantMembershipStatuses)[number];

export const tenantRoleKeys = [
  "platform-operator",
  "tenant-admin",
  "site-manager",
  "department-manager",
  "program-manager",
  "care-team-lead",
  "clinician",
  "patient",
  "scheduler",
  "document-coordinator",
  "integration-operator",
  "auditor",
  "support-read-only",
] as const;

export type TenantRoleKey = (typeof tenantRoleKeys)[number];

export const patientAccessModes = [
  "none",
  "assigned-only",
  "team-panel",
  "department-panel",
  "program-panel",
  "tenant-panel",
] as const;

export type PatientAccessMode = (typeof patientAccessModes)[number];

export interface PlatformActorIdentity {
  actorId: string;
  actorKind: PlatformActorKind;
  actorStatus: PlatformActorStatus;
  externalSubjectReference: string | null;
  displayName: string;
  emailAddress: string | null;
  mobileNumber: string | null;
  homeTenantId: string | null;
  metadata: Record<string, unknown>;
}

export interface TenantMembershipScope {
  kind: MembershipScopeKind;
  tenantId: string;
  siteId: string | null;
  departmentId: string | null;
  serviceLineId: string | null;
  programId: string | null;
  careTeamId: string | null;
}

export interface TenantMembership {
  membershipId: string;
  actorId: string;
  tenantId: string;
  status: TenantMembershipStatus;
  roleKeys: TenantRoleKey[];
  scope: TenantMembershipScope;
  patientAccessMode: PatientAccessMode;
  canManageUsers: boolean;
  canManageConnectors: boolean;
  canReviewAudit: boolean;
  metadata: Record<string, unknown>;
}

export interface TenantAwarePatientReference {
  tenantId: string;
  canonicalPatientId: string;
  siteIds: string[];
  departmentIds: string[];
  programIds: string[];
  careTeamIds: string[];
  assignmentActorIds: string[];
}
